module.exports = __webpack_public_path__ + "img/cookedInParis.d6ea262f.png";